window.SwymWishlist = window.SwymWishlist || {};

SwymWishlist.getShareUrl = async function() {
  const products = SwymWishlist.state?.products || [];
  if (products.length === 0) {
    return window.location.href;
  }

  return SwymWishlist.generateFallbackShareUrl();
};

SwymWishlist.generateFallbackShareUrl = function() {
  const products = SwymWishlist.state?.products || [];
  const handles = products.map(p => {
    const match = p.du?.match(/\/products\/([^?#]+)/);
    return match ? match[1] : null;
  }).filter(Boolean);
  const encoded = btoa(handles.join(','))
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/, '');
  return `${window.location.origin}${window.location.pathname}?shared=${encoded}`;
};

SwymWishlist.parseSharedProducts = function(encoded) {
  try {
    let b64 = encoded.replace(/-/g, '+').replace(/_/g, '/');
    while (b64.length % 4) b64 += '=';
    const decoded = atob(b64);
    return decoded.split(',').filter(Boolean);
  } catch (e) {
    return null;
  }
};

SwymWishlist.initShareButtons = function(shareTitle) {
  const shareTrigger = document.getElementById('swym-share-trigger');
  const shareFacebook = document.getElementById('swym-share-facebook');
  const shareX = document.getElementById('swym-share-x');
  const sharePinterest = document.getElementById('swym-share-pinterest');
  const shareCopy = document.getElementById('swym-share-copy');

  if (shareTrigger && navigator.share) {
    shareTrigger.addEventListener('click', async function() {
      try {
        const url = await SwymWishlist.getShareUrl();
        await navigator.share({
          title: shareTitle,
          url: url
        });
      } catch (err) {}
    });
  }

  if (shareFacebook) {
    shareFacebook.addEventListener('click', async function(e) {
      e.preventDefault();
      const url = encodeURIComponent(await SwymWishlist.getShareUrl());
      window.open(`https://www.facebook.com/sharer/sharer.php?u=${url}`, '_blank', 'width=600,height=400');
    });
  }

  if (shareX) {
    shareX.addEventListener('click', async function(e) {
      e.preventDefault();
      const url = encodeURIComponent(await SwymWishlist.getShareUrl());
      const text = encodeURIComponent(shareTitle);
      window.open(`https://twitter.com/intent/tweet?url=${url}&text=${text}`, '_blank', 'width=600,height=400');
    });
  }

  if (sharePinterest) {
    sharePinterest.addEventListener('click', async function(e) {
      e.preventDefault();
      const url = encodeURIComponent(await SwymWishlist.getShareUrl());
      const desc = encodeURIComponent(shareTitle);
      window.open(`https://pinterest.com/pin/create/button/?url=${url}&description=${desc}`, '_blank', 'width=600,height=400');
    });
  }

  if (shareCopy) {
    shareCopy.addEventListener('click', async function() {
      try {
        const url = await SwymWishlist.getShareUrl();
        await navigator.clipboard.writeText(url);
        const label = shareTrigger?.querySelector('.product-share__label');
        if (label) {
          const originalText = label.textContent;
          label.textContent = shareCopy.dataset.shareCopied || 'Copied!';
          setTimeout(() => { label.textContent = originalText; }, 2000);
        }
      } catch (err) {}
    });
  }
};

SwymWishlist.loadSharedProducts = async function(handles, callback) {
  SwymWishlist.state.isSharedView = true;
  const shareBlock = document.querySelector('.swym-wishlist__share');
  if (shareBlock) {
    shareBlock.style.display = 'none';
  }

  const localized = (path) => (
    SwymWishlist.getLocalizedPath ? SwymWishlist.getLocalizedPath(path) : path
  );

  const fetchProduct = async (handle) => {
    try {
      let response = await fetch(localized(`/products/${handle}.json`));

      if (response.status === 404) {
        const pageRes = await fetch(localized(`/products/${handle}`));
        const resolvedHandle = pageRes.url.split('/products/')[1]?.split(/[?#]/)[0];
        if (resolvedHandle && resolvedHandle !== handle) {
          response = await fetch(localized(`/products/${resolvedHandle}.json`));
        }
      }

      if (response.ok) {
        const data = await response.json();
        const product = data.product;
        if (product) {
          const variant = product.variants?.[0];
          return {
            empi: product.id,
            epi: variant?.id,
            dt: product.title,
            du: `/products/${product.handle}`,
            iu: product.images?.[0]?.src || '',
            pr: parseFloat(variant?.price || 0)
          };
        }
      }
    } catch (e) {}
    return null;
  };

  const results = await Promise.all(handles.map(fetchProduct));
  const products = results.filter(Boolean);

  if (callback) callback(products);
};
